/*
 * WC-SWATCH-TIPS.JS  -  a short description of each colour, on the swatch
 * ---------------------------------------------------------------------------
 *
 * Horizon draws the colour choice as a row of coloured circles once the
 * option values carry swatches (tools/set-colour-swatches.js). It names the
 * chosen colour in the row's heading ("Colour  Red") and nowhere else. This
 * does two things.
 *
 * FIRST, IT DRAWS THE CIRCLES SHOPIFY CANNOT. A product has one Color
 * field, and only one option can be connected to it. Bar Ends has Body and
 * Band Colour, Gear Station has Primary and Secondary Colour: the second
 * option of each is a row of text buttons for ever as far as Shopify is
 * concerned. For any colour row whose values are all in HEX below and that
 * Horizon has not already drawn as swatches, this rebuilds the row with
 * Horizon's own swatch markup (fieldset.variant-option--swatches, a
 * span.swatch per value with --swatch-background), so Horizon's stylesheet
 * draws it and it is indistinguishable from a connected one. The inputs
 * are untouched, so choosing a variant works exactly as before.
 *
 * SECOND, it names each circle (TIPS below; since 15 October just the
 * colour's name, earlier a short description):
 *
 *   - resting the pointer on a circle (or tabbing to it) shows a small tip
 *     above it with the words;
 *   - the words for the CHOSEN colour are printed in a line under the
 *     row, so a phone, which has no pointer, sees it too.
 *
 * The colour name itself is hidden by when-create.css (section "THE COLOUR
 * SWATCHES"); the radio input still carries it as aria-label, so a screen
 * reader hears "Red" as before.
 *
 * THE WORDS ARE BELOW, IN TIPS. Edit them there. A colour with no entry
 * gets no tip and no line, nothing else changes.
 *
 * HOW IT SURVIVES HORIZON REDRAWING THE PICKER
 * Every time a different value is chosen, Horizon fetches the page again
 * and morphs the picker in place, which throws away anything written into
 * it. So nothing here is attached to the swatches themselves: the tip is one
 * element on <body>, driven by events that bubble up to the document, and
 * the line under the row is re-created whenever the picker changes
 * (MutationObserver). Both keep working after a morph.
 *
 * Selectors come from Horizon's own snippets/variant-main-picker.liquid
 * (4.2.0): fieldset.variant-option--swatches holds one
 * label.variant-option__button-label--has-swatch per value, each with the
 * radio input whose value is the colour name.
 *
 * Deliberately a script rather than an edit to Horizon's snippet: that file
 * is stock Horizon, and this project keeps no copy of stock Horizon.
 * Removing the <script> line in theme.liquid removes all of this.
 */
(function () {
  'use strict';

  /* ---- THE WORDS. Decided 15 October 2026: just the colour's name, no
     description. The tip and the line under the row say "Red", so a
     circle is never a guess. To describe a colour again, put the words
     here; one short sentence each. ---------------------------------- */
  var TIPS = {
    'Black':  'Black',
    'White':  'White',
    'Blue':   'Blue',
    'Orange': 'Orange',
    'Yellow': 'Yellow',
    'Red':    'Red'
  };

  /* The circle colours for rows this script draws: Bambu Lab's hex codes
     for PETG Basic since 20 October 2026, the same six values as the Color
     entries on Shopify, so a drawn row matches a connected one on the same
     page. If the entries are ever recoloured
     (set-colour-swatches.js --recolour), change these to match. */
  var HEX = {
    'Black':  '#000000',
    'White':  '#FFFFFF',
    'Blue':   '#001489',
    'Orange': '#FF671F',
    'Yellow': '#FCE300',
    'Red':    '#D6001C'
  };

  var LABEL = '.variant-option__button-label--has-swatch';
  var ROW = 'fieldset.variant-option--swatches';
  var TEXT_ROW = 'fieldset.variant-option--buttons:not(.variant-option--swatches)';
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  /* ---- the tip above a swatch ----------------------------------------- */
  var tip = null;

  function ensureTip() {
    if (tip) return tip;
    tip = document.createElement('div');
    tip.className = 'wc-swatch-tip';
    tip.setAttribute('role', 'tooltip');
    tip.hidden = true;
    document.body.appendChild(tip);
    return tip;
  }

  function labelOf(el) {
    return el && el.closest ? el.closest(LABEL) : null;
  }

  function nameOf(label) {
    var input = label.querySelector('input[type="radio"]');
    return input ? input.value : '';
  }

  function show(label) {
    var text = TIPS[nameOf(label)];
    if (!text) return hide();
    var t = ensureTip();
    t.textContent = text;
    t.hidden = false;

    var r = label.getBoundingClientRect();
    var w = t.offsetWidth;
    var h = t.offsetHeight;
    var left = Math.max(8, Math.min(r.left + r.width / 2 - w / 2, window.innerWidth - w - 8));
    var top = r.top - h - 10;
    var below = top < 8;
    if (below) top = r.bottom + 10;
    t.style.left = left + 'px';
    t.style.top = top + 'px';
    /* the little arrow points at the swatch from whichever side the tip is on */
    t.style.setProperty('--wc-tip-arrow', (r.left + r.width / 2 - left) + 'px');
    t.classList.toggle('wc-swatch-tip--below', below);
  }

  function hide() {
    if (tip) tip.hidden = true;
  }

  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var l = labelOf(e.target);
      if (l) show(l);
    });
    document.addEventListener('mouseout', function (e) {
      var l = labelOf(e.target);
      if (l && !l.contains(e.relatedTarget)) hide();
    });
  }
  document.addEventListener('focusin', function (e) {
    var l = labelOf(e.target);
    if (l) show(l);
  });
  document.addEventListener('focusout', hide);
  window.addEventListener('scroll', hide, { passive: true });
  window.addEventListener('resize', hide);

  /* ---- the line under the row: the chosen colour ---------------------- */
  function describe(row) {
    var checked = row.querySelector('input[type="radio"]:checked');
    var text = checked ? TIPS[checked.value] : '';
    var line = row.querySelector('.wc-swatch-desc');
    if (!text) {
      if (line) line.remove();
      return;
    }
    if (!line) {
      line = document.createElement('p');
      line.className = 'wc-swatch-desc';
      row.appendChild(line);
    }
    if (line.textContent !== text) line.textContent = text;
  }

  /* ---- drawing the rows Shopify could not connect ---------------------- */
  function isColourRow(row) {
    var legend = row.querySelector('legend');
    return !!legend && /colou?r/i.test(legend.textContent);
  }

  function paint(row) {
    if (!isColourRow(row)) return;
    var inputs = row.querySelectorAll('input[type="radio"]');
    if (!inputs.length) return;
    for (var i = 0; i < inputs.length; i++) {
      if (!HEX[inputs[i].value]) return;   /* a value with no colour: leave the row as text */
    }
    row.classList.add('variant-option--swatches');
    row.classList.remove('variant-option--equal-width-buttons');
    row.classList.remove('variant-option--auto-width-buttons');
    for (var j = 0; j < inputs.length; j++) {
      var input = inputs[j];
      var label = input.closest('label');
      if (!label) continue;
      label.classList.add('variant-option__button-label--has-swatch');
      var old = label.querySelectorAll('.variant-option__button-label__pill, .variant-option__button-label__text');
      for (var k = 0; k < old.length; k++) old[k].remove();
      var sw = document.createElement('span');
      sw.className = 'swatch swatch--unscaled';
      sw.style.setProperty('--swatch-background', HEX[input.value]);
      input.insertAdjacentElement('afterend', sw);
    }
  }

  function refresh() {
    var text = document.querySelectorAll(TEXT_ROW);
    for (var t = 0; t < text.length; t++) paint(text[t]);
    var rows = document.querySelectorAll(ROW);
    for (var i = 0; i < rows.length; i++) describe(rows[i]);
  }

  /* One refresh per frame however many mutations arrive. refresh() changes
     nothing when nothing changed, so it does not feed the observer that
     called it. */
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      refresh();
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(ROW + ' input[type="radio"]')) schedule();
  });

  function start() {
    refresh();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
